module.exports = __webpack_public_path__ + "img/emotions.b790fac.svg";